import { useContent } from '@/lib/content-context'
import { useUX } from '@/ux/context'
import { selectVariant } from '@/ux/selectors'
import { RecruiterHero } from './RecruiterHero'
import { EngineerHero } from './EngineerHero'

export function Hero() {
  const { profile, links } = useContent()
  const ux = useUX()
  const variant = selectVariant('Hero', ux)

  if (variant === 'EngineerHero') {
    return <EngineerHero profile={profile} links={links} />
  }

  return <RecruiterHero profile={profile} links={links} />
}
